import { message, notification, Select } from "antd";
import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import LogBookLoginRequired from "../../hooks/LogBookLoginRequired";

export default function EmployeeProcessManagement() {
  const [ formData, setFormData] = React.useState({
    id: "",
    visitorType: "",
    visitorId: "",
    visitorName: "",
    purposeOfVisit: "",
    phoneNumber: "",
    email: "",
    date: "",
    inTime: "",
    authorizedSignatory: "",
    facility: "",
    requestRaisedBy:""
  });

  const { Option } = Select;
  const navigate=useNavigate();

  const [errors, setErrors] = React.useState({});
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [submitMessage, setSubmitMessage] = React.useState("");
  const [isDrawing, setIsDrawing] = useState(false);
  const [signatureData, setSignatureData] = useState(null);

  const role=localStorage.getItem("role")

  // Get current date in YYYY-MM-DD format for date input min attribute
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const getMaxDate=()=>{
    const today = new Date();
  today.setMonth(today.getMonth() + 6);
  return today.toISOString().split("T")[0];

  }
  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    console.log(name);
  
    // === VISITOR ID VALIDATION ===
    if (name === "visitorId") {
      const valueTrimmed = value.trim();
    
      const isFiveChars = valueTrimmed.length === 5;
      const hasOnlyAlphanum = /^[a-zA-Z0-9]+$/.test(valueTrimmed);
      const letterCount = (valueTrimmed.match(/[a-zA-Z]/g) || []).length;
      const digitCount = (valueTrimmed.match(/\d/g) || []).length;
    
      const isValid =
        isFiveChars &&
        hasOnlyAlphanum &&
        ((letterCount === 1 && digitCount === 4) || (letterCount === 0 && digitCount === 5));
    
      if (!isValid) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Enter a valid UID",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    
      return;
    }
    
    
    
    // === PHONE NUMBER VALIDATION ===
    if (name === "phoneNumber") {
      const onlyDigits = /^\d+$/;
  
      if (!onlyDigits.test(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Only digits are allowed",
        }));
      } else if (value.length > 10) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Phone number can only have 10 digits",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
  
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      return;
    }
  
    // === EMAIL VALIDATION ===
    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
      if (!emailRegex.test(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Invalid email format",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
  
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      return;
    }
  
    // === VISITOR TYPE CHANGE ===
    if (name === "visitorType") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        visitorId: value === "guest" ? "" : prev.visitorId,
      }));
  
      if (errors.visitorId) {
        setErrors((prev) => ({
          ...prev,
          visitorId: "",
        }));
      }
      return;
    }
  
    // === ALPHABET-ONLY VALIDATION ===
    if (name === "visitorName" || name === "purposeOfVisit" ||name==="onBehalfOfName") {
      const onlyAlphabets = /^[A-Za-z\s]*$/;
  
      if (!onlyAlphabets.test(value) && value !== "" ||  value.length>50) {
        setErrors((prev) => ({
          ...prev,
          [name]: "The "+name+" should contain only alphabets and characters less than 50",
        }));
        return;
      }
    }
  
    // === DEFAULT: UPDATE STATE ===
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };
  
  
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "visitorType",
      "visitorName",
      "purposeOfVisit",
      "phoneNumber",
      "date",
      "inTime",
      "facility",
      "email",
      "requestRaisedBy"
    ];

    // Add visitorId as required only for employees
    if (formData.visitorType === "employee") {
      requiredFields.push("visitorId");
    }
    if(formData.requestRaisedBy==="on-behalf-of"){
      requiredFields.push("onBehalfOfName")
    }
  
    
    if(role==="SUPERUSER"){   
      requiredFields.push("authorizedSignatory")
    }

    requiredFields.forEach((field) => {
      console.log(field);
      
      if (!formData[field]) {
        newErrors[field] = "This field is required";
      }
    });

    if (formData.visitorName && !/^[A-Za-z\s]+$/.test(formData.visitorName)) {
      newErrors.visitorName = "Only alphabets and spaces are allowed";
    }
    if(formData.visitorId && !/^[a-zA-Z0-9]{5}$/.test(formData.visitorId)) {
      newErrors.visitorId="Enter a valid UID"
    }

    if (
      formData.purposeOfVisit &&
      !/^[A-Za-z\s]+$/.test(formData.purposeOfVisit)
    ) {
      newErrors.purposeOfVisit = "Only alphabets and spaces are allowed";
    }
  

    if (formData.phoneNumber && !/^\d{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Please enter a valid 10-digit phone number";
    }

    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    const selectedDate = new Date(formData.date);
    const today = new Date();
    const oneYearFromToday = new Date();
    oneYearFromToday.setFullYear(today.getFullYear() + 1);
    today.setHours(0, 0, 0, 0);

    if (selectedDate < today) {
      newErrors.date = "Cannot select a past date";
    }
    if (selectedDate > oneYearFromToday) {
      newErrors.date = "Cannot select a date more than a year from today";
    }

    const parseTime = (timeStr) => {
      const [hours, minutes] = timeStr.split(":");
      const now = new Date();
      now.setHours(hours, minutes, 0, 0);
      return now;
    };

    if (formData.date === getCurrentDate()) {
      const selectedTime = formData.inTime;
      const currentTime = getCurrentTime();

      if (selectedTime < currentTime) {
        newErrors.inTime = "Cannot select a past time for today";
      }
    }
    if(role==="SUPERUSER" && !formData.authorizedSignatory){
      newErrors.authorizedSignatory="Authorized Signatory is required"
    }

    if (role==="SUPERUSER" &&!signatureData) {
      newErrors.eSignature = "E-Signature is required";
    }

    setErrors(newErrors);
    console.log(newErrors);
    
    return Object.keys(newErrors).length === 0;
  };

  // Save entry to localStorage
  const saveEntryToStorage = (entry) => {
    const existingEntries = JSON.parse(
      localStorage.getItem("visitorEntries") || "[]"
    );
    const newEntry = {
      key: Date.now().toString(),
      visitorUid: entry.visitorType === "employee" ? entry.visitorId : "---",
      visitorType: entry.visitorType === "employee" ? "Employee" : "Guest",
      visitorName: entry.visitorName,
      date: entry.date,
      inTime: entry.inTime,
      purpose: entry.purposeOfVisit,
      facility:
        entry.facility.charAt(0).toUpperCase() + entry.facility.slice(1), // Changed from addFacility to facility
      status: entry.status,
      phoneNumber: entry.phoneNumber,
      email: entry.email || "---",
    };
    existingEntries.push(newEntry);
    localStorage.setItem("visitorEntries", JSON.stringify(existingEntries));
  };

  const saveSignatureLocally = async (id) => {
    const canvas = document.getElementById("signatureCanvas");
    if (!canvas) throw new Error("Canvas not found");

    const dataURL = canvas.toDataURL("image/png");
    const blob = await (await fetch(dataURL)).blob();

    const formData = new FormData();
    const fileName = `${id || Date.now()}.png`;
    formData.append("file", blob, fileName);
    console.log(formData)

    try {
      const uploadResponse = await fetch(
        "https://techsolutionsservice.ustdev.com/api/logbook/sign/upload",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!uploadResponse.ok) throw new Error("Upload failed");

      const savedPath = `/signatures/${fileName}`;
      return savedPath;
    } catch (err) {
      console.error("Signature upload error:", err);
      throw new Error("Failed to save signature");
    }

  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(validateForm());
    
    if (validateForm()) {
      setIsSubmitting(true);
      setSubmitMessage("");
      console.log(formData.date + formData.inTime);

      try {
        // Transform data to match backend expectations
        const backendData = {
          visitorType: formData.visitorType.toUpperCase(),
          visitorId: formData.visitorId || null,
          requestedBy:localStorage.getItem("Name"),
          onBehalfOf:formData.onBehalfOfName || "NA",
          visitorName: formData.visitorName,
          purposeOfVisit: formData.purposeOfVisit,
          phoneNumber: formData.phoneNumber,
          email: formData.email || null,
          date: formData.date,
          inTime: formData.inTime,
          facility: formData.facility.toUpperCase(),
          status: role == "SUPERUSER" ? "APPROVED" : "ACTIVE",
        };

        if (role == "SUPERUSER") {
        
        let path;
        if (signatureData) {
          path = await saveSignatureLocally(formData.visitorId);
        }
          backendData.authorizedSignatory = formData.authorizedSignatory;
          backendData.signatureFilePath = path;
        }

        console.log("Sending data:", backendData);

        const response = await fetch("https://techsolutionsservice.ustdev.com/logbook/api/save", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(backendData),
        });

        let result;
        const contentType = response.headers.get("content-type");

        if (contentType && contentType.includes("application/json")) {
          result = await response.json();
        } else {
          // Handle non-JSON responses
          const textResponse = await response.text();
          result = { success: false, message: textResponse };
        }

        console.log("Response status:", response.status);
        console.log("Response result:", result);

        if (response.ok && result.success) {
          // Save to localStorage for ViewEntries component
          saveEntryToStorage(formData);
          setSubmitMessage("New entry created successfully!");
          navigate("/logbook/view-entries");
        } else {
          // Handle different error scenarios
          if (response.status === 400) {
            setSubmitMessage(
              `Validation Error: ${result.message || "Invalid request data"}`
            );
          } else if (response.status === 401) {
            setSubmitMessage("Authentication failed. Please login again.");
          } else if (response.status === 403) {
            setSubmitMessage(
              "Access forbidden. You do not have permission to perform this action."
            );
          } else {
            setSubmitMessage(
              `Error: ${result.message || "Failed to create entry"}`
            );
          }
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        setSubmitMessage(`Network Error: ${error.message}`);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleCancel = () => {
    navigate('/logbook/view-entries')
    setFormData({
      visitorType: "",
      visitorId: "",
      visitorName: "",
      purposeOfVisit: "",
      phoneNumber: "",
      email: "",
      date: "",
      inTime: "",
      facility: "", // Changed from addFacility to facility
    });
    setErrors({});
    setSubmitMessage(""); // Clear any success/error messages when canceling
  };

  const startDrawing = (e) => {
    const canvas = e.target;
    const ctx = canvas.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    setIsDrawing(true);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    const canvas = e.target;
    const ctx = canvas.getContext("2d");
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "black";
    ctx.lineTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    ctx.stroke();
  };

  const stopDrawing = (e) => {
    if (isDrawing) {
      const canvas = e.target;
      setSignatureData(canvas.toDataURL());
      setIsDrawing(false);
    }
  };

  const clearSignature = () => {
    const canvas = document.getElementById("signatureCanvas");
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setSignatureData(null);
  };

  if(localStorage.getItem('isLogBookLoggedIn') !== 'true'){
    LogBookLoginRequired();
   }

  return (
    <div className="mx-auto max-w-[1400px] w-full">
  <div className="rounded-lg shadow-sm px-6 py-9">
    <h2 className="text-2xl font-semibold text-start text-gray-800 mb-8">
      CREATE NEW ENTRY
    </h2>

    {submitMessage && (
      <div
        className={`p-3 mb-6 rounded ${
          submitMessage.includes("Error")
            ? "bg-red-100 text-red-700"
            : "bg-green-100 text-green-700"
        }`}
      >
        {submitMessage}
      </div>
    )}

    <form onSubmit={handleSubmit}>
      {/* Two Column Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        {/* First Column - Visitor Details */}
        <div className="space-y-6">
                    <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="text-red-500">*</span>Request Raised By
            </label>
            <div className="relative w-full">
              <select
                name="requestRaisedBy"
                value={formData.requestRaisedBy}
                onChange={handleChange}
                className={`w-full px-3 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white ${
                  errors.requestRaisedBy ? "border-red-500" : ""
                }`}
              >
                <option value="" hidden></option>
                <option value="me">Me</option>
                <option value="on-behalf-of">On Behalf Of</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-700">
                <svg
                  className="w-4 h-4"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
            {errors.requestRaisedBy && (
              <p className="text-red-500 text-xs mt-1">
                {errors.requestRaisedBy}
              </p>
            )}
          </div>

          {formData.requestRaisedBy === "on-behalf-of" && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <span className="text-red-500">*</span>On Behalf Of Person Name
              </label>
              <input
                maxLength={50}
                type="text"
                name="onBehalfOfName"
                value={formData.onBehalfOfName}
                onChange={handleChange}
                placeholder="Enter person name"
                className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                  errors.onBehalfOfName ? "border-red-500" : ""
                }`}
              />
              {errors.onBehalfOfName && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.onBehalfOfName}
                </p>
              )}
            </div>
          )}
          {/* Visitor Type */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="text-red-500">*</span>Visitor Type
            </label>
            <div className="relative w-full">
              <select
                name="visitorType"
                value={formData.visitorType}
                onChange={handleChange}
                className={`w-full px-3 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white ${
                  errors.visitorType ? "border-red-500" : ""
                }`}
              >
               <option value="" hidden></option>
                <option value="employee">Employee</option>
                <option value="guest">Guest</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-700">
                <svg
                  className="w-4 h-4"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
            {errors.visitorType && (
              <p className="text-red-500 text-xs mt-1">
                {errors.visitorType}
              </p>
            )}
          </div>

          {/* Visitor ID */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {formData.visitorType === "employee" && (
                <span className="text-red-500">*</span>
              )}
              Employee ID
            </label>
            <input
              maxLength={5}
              type="text"
              name="visitorId"
              value={formData.visitorId}
              onChange={handleChange}
              disabled={formData.visitorType !== "employee"}
              placeholder={formData.visitorType === "employee" ? "Enter employee ID" : "N/A"}
              className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                formData.visitorType !== "employee"
                  ? "bg-gray-100 cursor-not-allowed"
                  : ""
              } ${errors.visitorId ? "border-red-500" : ""}`}
            />
            {errors.visitorId && (
              <p className="text-red-500 text-xs mt-1">
                {errors.visitorId}
              </p>
            )}
          </div>

          {/* Visitor Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="text-red-500">*</span>Visitor Name
            </label>
            <input
              maxLength={50}
              type="text"
              name="visitorName"
              value={formData.visitorName}
              onChange={handleChange}
              placeholder="Enter visitor name"
              className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                errors.visitorName ? "border-red-500" : ""
              }`}
            />
            {errors.visitorName && (
              <p className="text-red-500 text-xs mt-1">
                {errors.visitorName}
              </p>
            )}
          </div>

          {/* Phone Number */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="text-red-500">*</span>Phone Number
            </label>
            <input
              type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                errors.phoneNumber ? "border-red-500" : ""
              }`}
              placeholder="10 digit number"
            />
            {errors.phoneNumber && (
              <p className="text-red-500 text-xs mt-1">
                {errors.phoneNumber}
              </p>
            )}
          </div>

        </div>

        {/* Second Column - Visit Details */}
        <div className="space-y-6">
                    {/* Email */}
                    <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
            <span className="text-red-500">*</span>   Email ID
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email address"
              className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                errors.email ? "border-red-500" : ""
              }`}
            />
            {errors.email && (
              <p className="text-red-500 text-xs mt-1">{errors.email}</p>
            )}
          </div>

          {/* Purpose of Visit */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="text-red-500">*</span>Purpose of Visit
            </label>
            <input
            max={50}
              type="text"
              name="purposeOfVisit"
              value={formData.purposeOfVisit}
              onChange={handleChange}
              placeholder="Enter purpose of visit"
              className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                errors.purposeOfVisit ? "border-red-500" : ""
              }`}
            />
            {errors.purposeOfVisit && (
              <p className="text-red-500 text-xs mt-1">
                {errors.purposeOfVisit}
              </p>
            )}
          </div>

          {/* Facility */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="text-red-500">*</span>Facility
            </label>
            <div className="relative w-full">
              <select
                name="facility"
                value={formData.facility}
                onChange={handleChange}
                className={`w-full px-3 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white ${
                  errors.facility ? "border-red-500" : ""
                }`}
              >
                <option value="" hidden></option>
                <option value="bangalore">Bangalore</option>
                <option value="trivandrum">Trivandrum</option>
                <option value="kochi">Kochi</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-700">
                <svg
                  className="w-4 h-4"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
                </div>
            </div>
            {errors.facility && (
              <p className="text-red-500 text-xs mt-1">{errors.facility}</p>
            )}
          </div>

          {/* Date */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="text-red-500">*</span>Date
            </label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              min={getCurrentDate()}
              max={getMaxDate()}
              className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                errors.date ? "border-red-500" : ""
              }`}
            />
            {errors.date && (
              <p className="text-red-500 text-xs mt-1">{errors.date}</p>
            )}
          </div>

          {/* In Time */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="text-red-500">*</span>In Time
            </label>
            <input
              type="time"
              name="inTime"
              value={formData.inTime}
              onChange={handleChange}
              min={
                formData.date === getCurrentDate() ? getCurrentTime() : null
              }
              className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                errors.inTime ? "border-red-500" : ""
              }`}
            />
            {errors.inTime && (
              <p className="text-red-500 text-xs mt-1">{errors.inTime}</p>
            )}
          </div>
        </div>
      </div>

      {/* Authorized Access Section - Only for SUPERUSER */}
      {role === "SUPERUSER" && (
        <div className="mt-8 bg-white rounded-xl shadow-lg border border-gray-200">
          <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 rounded-t-xl">
            <h2 className="text-center font-semibold text-gray-800 text-lg tracking-wide">
              AUTHORIZED ACCESS
            </h2>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
              {/* Left Column - Authorized Signatory */}
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  <span className="text-red-500">*</span>Authorized Signatory
                </label>
                <Select
                  name="authorizedSignatory"
                  value={formData.authorizedSignatory}
                  defaultValue={formData.authorizedSignatory}
                  onChange={(value) =>
                    handleChange({
                      target: { name: "authorizedSignatory", value },
                    })
                  }
                  disabled={role === "ADMINUSER"}
                  className={`w-full h-[40px] border rounded-md ${
                    errors.authorizedSignatory ? "border-red-500" : "border-gray-300"
                  } ${
                    role === "ADMINUSER"
                      ? "bg-gray-100 text-gray-600"
                      : "bg-white"
                  }`}
                >
                  <Select.Option value={`${localStorage.getItem("Name")}`}>
                    {localStorage.getItem("Name")}
                  </Select.Option>
                </Select>
                {errors.authorizedSignatory && (
  <span className="text-red-500">{errors.authorizedSignatory}</span>
)}
              </div>

              {/* Right Column - E-Signature */}
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  <span className="text-red-500">*</span>E-Signature
                </label>
                <div
                  className={`border rounded-md p-4 ${
                    role === "ADMINUSER" ? "bg-gray-100" : "bg-white"
                  } ${
                    errors.eSignature ? "border-red-500" : "border-gray-300"
                  }`}
                >
                  <canvas
                    id="signatureCanvas"
                    width="350"
                    height="120"
                    className={`w-full border border-gray-200 rounded ${
                      role !== "ADMINUSER"
                        ? "cursor-crosshair bg-gray-50"
                        : "bg-gray-100 cursor-not-allowed"
                    }`}
                    onMouseDown={role !== "ADMINUSER" ? startDrawing : undefined}
                    onMouseMove={role !== "ADMINUSER" ? draw : undefined}
                    onMouseUp={role !== "ADMINUSER" ? stopDrawing : undefined}
                    onMouseLeave={role !== "ADMINUSER" ? stopDrawing : undefined}
                  />
                  <button
                    type="button"
                    onClick={role !== "ADMINUSER" ? clearSignature : undefined}
                    disabled={role === "ADMINUSER"}
                    className="mt-3 px-4 py-2 text-sm border border-gray-300 rounded-md bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  >
                    Clear
                  </button>
                </div>
                {errors.eSignature && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.eSignature}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Buttons */}
      <div className="flex justify-center gap-4 mt-8 mb-10">
        <button
          type="submit"
          disabled={isSubmitting}
          className="bg-slate-700 hover:bg-slate-800 text-white font-medium py-2 px-8 rounded-full focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {isSubmitting ? "Saving..." : "Save"}
        </button>
        <button
          type="button"
          onClick={handleCancel}
          className="bg-slate-700 hover:bg-slate-800 text-white font-medium py-2 px-8 rounded-full focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-opacity-50 transition-colors"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>
  );
}
